import script from "./PaymentLinkListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentLinkListPage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentLinkListPage.vue?vue&type=style&index=0&id=648b1df7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648b1df7"]])

export default __exports__